import { Injectable } from '@angular/core';
import { QueryEntity, transaction } from '@datorama/akita';
import { CacheObservable } from '@lycoris-nubila/ngx-lycoris';
import { isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { UserModuleSuggestionRepositoryPort } from 'user/port/suggestion/user-module-suggestion-repository.port';
import {
	IUserModuleSuggestion,
	UserModuleSuggestion,
} from 'user/suggestion/user-module-suggestion';
import {
	UserModuleSuggestionsState,
	UserModuleSuggestionsStore,
} from 'user/suggestion/user-module-suggestion.store';

@Injectable()
export class UserModuleSuggestionRepositoryAdapter
	extends QueryEntity<UserModuleSuggestionsState>
	implements UserModuleSuggestionRepositoryPort
{
	constructor(protected store: UserModuleSuggestionsStore) {
		super(store);
	}

	@CacheObservable()
	public observeUserModuleSuggestions(
		userId: string
	): Observable<IUserModuleSuggestion[]> {
		return this.selectAll({ filterBy: (doc) => doc.userId === userId }).pipe(
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			shareReplay({ refCount: true, bufferSize: 1 })
		);
	}

	@transaction()
	public replaceUserModuleSuggestions(
		userId: string,
		entities: UserModuleSuggestion[]
	): void {
		this.store.remove((doc) => doc.userId === userId);

		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
